import { Tooltip, Typography, useTheme } from '@mui/material';
import { cn } from '../utils';
import { I18nTranslator } from '@strength/i18n';

const colorClasses = {
  gray: 'text-gray-600 bg-gray-50 border-gray-300',
};

type BadgeColor = keyof typeof colorClasses;

type BadgeProps = {
  label: string;
  tooltip?: { title?: string; description: string };
  color?: BadgeColor;
};

export function Badge({ label, tooltip, color = 'gray' }: BadgeProps) {
  const {
    palette: {
      mediumEmphasisTextDark,
      common: { white },
    },
  } = useTheme();
  const content = (
    <div
      className={cn(
        'w-fit text-xs rounded-full border px-2',
        colorClasses[color],
      )}
    >
      {label}
    </div>
  );

  if (!tooltip) return content;

  return (
    <Tooltip
      title={
        <div>
          {tooltip.title && (
            <Typography variant="subtitle1Semibold" color={white}>
              {tooltip.title}
            </Typography>
          )}

          {tooltip.description && (
            <Typography variant="subtitle1" color={mediumEmphasisTextDark}>
              {tooltip.description}
            </Typography>
          )}
        </div>
      }
      arrow
    >
      {content}
    </Tooltip>
  );
}

export const defaultExerciseBadge = (t: I18nTranslator) => ({
  label: t('default'),
  tooltip: {
    title: t('defaultExercise'),
    description: t('cannotDeleteDefaultExercise'),
  },
});

export default Badge;
